import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogContentText from '@material-ui/core/DialogContentText/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Tooltip from '@material-ui/core/Tooltip/index';

import ErrorIcon from '@material-ui/icons/Error';
import IconButton from '@material-ui/core/IconButton/index';
import Pageview from '@material-ui/icons/Pageview';

import {
  Rule,
  SoilDiagItem,
} from '../../../proptypes';

const MIN_WIDTH = 96;

export const Preview = (props) => {
  const {
    data,
    date,
    receiptId,
    receiptSubId,
    soilDiagRuleCode,
    soilDiagItems,
    soilDiagRules,
    title,
  } = props;

  const [isOpened, setIsOpened] = useState(false);

  // HACK!
  // e.stopPropagation()でクリックした時に背面の行が選択されるのを抑制してる
  const onClickOuter = useCallback((e) => {
    e.stopPropagation();
  }, []);
  const onClickOpen = useCallback((e) => {
    e.stopPropagation();
    setIsOpened(true);
  }, []);
  const onClickClose = useCallback((e) => {
    e.stopPropagation();
    setIsOpened(false);
  }, []);

  const values = data.reduce((memo, d) => {
    const item = soilDiagItems.find(i => i.id === d.itemId);
    if (item) {
      memo.push({
        name: item.name,
        unit: item.unit,
        value: d.computed,
      });
    }
    return memo;
  }, []);

  return (
    <div onClick={onClickOuter}>
      <IconButton onClick={onClickOpen}>
        <Pageview />
      </IconButton>
      <Dialog
        maxWidth="md"
        open={isOpened}
        onClose={onClickClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {/* {body} */}
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="center" style={{ minWidth: MIN_WIDTH }}>受付番号</TableCell>
                  <TableCell align="center" style={{ minWidth: MIN_WIDTH }}>枝番</TableCell>
                  <TableCell align="center" style={{ minWidth: MIN_WIDTH }}>受付日</TableCell>
                  <TableCell align="center" style={{ minWidth: MIN_WIDTH }}>診断基準コード</TableCell>
                  {
                    values.map(d => (
                      <TableCell key={d.name} align="center" style={{ minWidth: MIN_WIDTH }}>
                        {d.name}
                      </TableCell>
                    ))
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow key="row.v1">
                  <ValueCell value={receiptId} />
                  <ValueCell value={receiptSubId} />
                  <DateCell value={date} />
                  <RuleCell soilDiagRules={soilDiagRules} value={soilDiagRuleCode} />
                  {
                    values.map(d => <ValueCell key={d.name} value={d.value} />)
                  }
                </TableRow>
              </TableBody>
            </Table>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClickClose} color="primary" autoFocus>
            閉じる
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const Data = PropTypes.shape({
  itemId: PropTypes.number.isRequired,
  values: PropTypes.arrayOf(PropTypes.number).isRequired,
  computed: PropTypes.number.isRequired,
});

Preview.propTypes = {
  data: PropTypes.arrayOf(Data).isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  receiptId: PropTypes.number.isRequired,
  receiptSubId: PropTypes.number.isRequired,
  soilDiagItems: PropTypes.arrayOf(SoilDiagItem).isRequired,
  soilDiagRuleCode: PropTypes.string.isRequired,
  soilDiagRules: PropTypes.arrayOf(Rule).isRequired,
  title: PropTypes.string.isRequired,
};

const ValueCell = (props) => {
  const { value } = props;
  if (Number.isNaN(value)) {
    return (
      <TableCell align="center">
        <Tooltip title="値が正しくありません">
          <ErrorIcon color="error" />
        </Tooltip>
      </TableCell>
    );
  }
  return (
    <TableCell align="right">
      {value}
    </TableCell>
  );
};

ValueCell.propTypes = {
  value: PropTypes.number.isRequired,
};

const DateCell = (props) => {
  const { value } = props;
  if (!value || value === 'Invalid date') {
    return (
      <TableCell align="center">
        <Tooltip title="値が正しくありません">
          <ErrorIcon color="error" />
        </Tooltip>
      </TableCell>
    );
  }

  return (
    <TableCell align="right">
      {value}
    </TableCell>
  );
};

DateCell.propTypes = {
  value: PropTypes.instanceOf(Date).isRequired,
};

const RuleCell = (props) => {
  const {
    soilDiagRules,
    value,
  } = props;
  const codes = soilDiagRules.map(s => s.provider_code);
  if (!codes.includes(value)) {
    return (
      <TableCell align="center">
        <Tooltip title="値が正しくありません">
          <ErrorIcon color="error" />
        </Tooltip>
      </TableCell>
    );
  }

  return (
    <TableCell align="right">
      {value}
    </TableCell>
  );
};

RuleCell.propTypes = {
  soilDiagRules: PropTypes.arrayOf(Rule).isRequired,
  value: PropTypes.string.isRequired,
};
